import {useTrucks} from '@hconnect/tuc-processes/fields/trucks/useTrucks'
import CheckIcon from '@mui/icons-material/Check'
import {Box, Typography, List, ListItem, ListItemButton, ListItemText} from '@mui/material'
import React from 'react'
import {useTranslation} from 'react-i18next'

/**
 * Component for selecting truck type in the RMC order process
 * Designed to match Figma specifications with list design
 */
export const TruckTypeSelect: React.FC = () => {
  const {t} = useTranslation()
  const {truckType, setTruckType, configuration} = useTrucks()

  // If the feature is not enabled, don't render anything
  if (!configuration.isEnabled) {
    return null
  }

  return (
    <Box sx={{width: '100%'}}>
      {/* Title */}
      <Box sx={{marginBottom: '8px'}}>
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontWeight: 600,
            fontSize: '18px',
            lineHeight: '24px',
            color: '#29333d',
            textAlign: 'left'
          }}
        >
          {t('orderIntake.rmc.orderManagement.selectTruckType', 'Select Truck type')}
        </Typography>
      </Box>

      {/* Truck List */}
      <Box sx={{width: '100%'}}>
        <List
          sx={{
            padding: 0,
            width: '100%'
          }}
        >
          {configuration.truckTypes.values.map((option, index) => (
            <ListItem
              key={option.number}
              sx={{
                padding: 0,
                width: '100%'
              }}
            >
              <ListItemButton
                onClick={() => setTruckType(option.number)}
                selected={truckType === option.number}
                sx={{
                  backgroundColor: truckType === option.number ? '#f2f8fd' : '#ffffff',
                  borderBottom:
                    index === configuration.truckTypes.values.length - 1
                      ? 'none'
                      : '1px solid #e8ecf0',
                  padding: '12px 16px',
                  minHeight: 'auto',
                  width: '100%',
                  '&:hover': {
                    backgroundColor: '#f2f8fd'
                  },
                  '&.Mui-selected': {
                    backgroundColor: '#f2f8fd',
                    '&:hover': {
                      backgroundColor: '#f2f8fd'
                    }
                  }
                }}
                data-test-id={`rmc-truck-type-${option.number}`}
              >
                <ListItemText
                  primary={
                    <Typography
                      sx={{
                        fontFamily: 'Inter',
                        fontWeight: 400,
                        fontSize: '16px',
                        lineHeight: '24px',
                        color: '#29333d',
                        textAlign: 'left'
                      }}
                    >
                      {/* Translated label keyed by truck type code, falling back to the API description */}
                      {t(
                        `orderIntake.rmc.orderManagement.truckTypes.${option.number}`,
                        option.description
                      )}
                    </Typography>
                  }
                  sx={{
                    margin: 0,
                    flex: 1
                  }}
                />
                {truckType === option.number && (
                  <CheckIcon
                    sx={{
                      color: '#016ad4',
                      fontSize: '20px',
                      marginLeft: '16px'
                    }}
                  />
                )}
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Box>
  )
}
